import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard/newuser' // (1) NEW 회원 수

let swrData: any = getPersistData(KEY)

export function useNewUser() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.userCount

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		newUser: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}